// extracted by mini-css-extract-plugin
export default {"searchInputSm":"Search_searchInputSm__XsHZL","searchInputLg":"Search_searchInputLg__nmnh4","searchIcon":"Search_searchIcon__lbFwd"};